import { differenceInCalendarISOWeeks} from "date-fns";
import { useCallback, useEffect, useState } from "react"
import { PreParsedEvent, useAppContext } from "../AppContext";

import  * as EventFilters from "../EventFilters";
import React from "react";
import Chart from "react-google-charts";
import LoadingSpinner from "../LoadingSpinner";


type myProps = {

    startWeekDelta? :Number,
    endWeekDelta? :Number
}
export default function WeekBars(props:myProps){
    const app = useAppContext();
    const [weeklyData, setWeeklyData] = useState<any>(undefined)
    type clinicWeekData = {
        weekNumber?: number,
        openAppointmentCount: number,
        bookedAppointmentCount: number
        roundsCount: number
    }


    const roundsColor = "#6A2135";
    const bookedColor = '#E38627';
    const openColor = '#C13C37' ;

    const countImportantItems = useCallback((events: PreParsedEvent[], returnArray = false): clinicWeekData => {
        const openAppointmentCount = new EventFilters.EventFilters(events).Free().events.length
        const bookedAppointmentCount = events.filter((x)=>EventFilters.is_appointment(x)).length
        const roundsCount = events.filter((x)=>EventFilters.is_rounds(x)).length

        return {
            openAppointmentCount : openAppointmentCount,
            bookedAppointmentCount: bookedAppointmentCount,
            roundsCount: roundsCount
        }
    },[])
const columnChart = useCallback(()=>{

    let weeks: (string | number)[][] = []
    let now = new Date()

    let local_week = new Array<PreParsedEvent>()

    const originalStartWeek = -10000
    let local_week_number = originalStartWeek
    //assumes events come sorted (in start time order )
    app.events?.forEach(event => {
        const date_of_event = new Date(event.startDateUTCMilliseconds)
        let currentWeekNumber = differenceInCalendarISOWeeks(date_of_event, now)
        if((props.startWeekDelta!==undefined && currentWeekNumber<props.startWeekDelta) || (props.endWeekDelta!==undefined && currentWeekNumber>props.endWeekDelta)){
            return //dont include this event
        }

        if(currentWeekNumber>local_week_number){
            if(local_week_number!==originalStartWeek){
            let importantCountsFromLastWeek = countImportantItems(local_week)
            weeks.push(
                [local_week_number.toString(), 
                importantCountsFromLastWeek.roundsCount,
                importantCountsFromLastWeek.bookedAppointmentCount,
                importantCountsFromLastWeek.openAppointmentCount,
               ]
                )
            }
            local_week_number = currentWeekNumber
            local_week = []
            local_week.push(event)
        }else{
            local_week.push(event)
        }
        
    });
   
    let weeks_with_headders = [["Week Number", "Rounds", "Booked", "Open"], ...weeks]
    //console.log(weeks_with_headders)
    return weeks_with_headders
   
},[app.events]) 

useEffect(() => {
    
    if(app.events){
        setWeeklyData(columnChart)
    }
}, [app.events,columnChart])

const loaderElement = <LoadingSpinner />

return(
    <React.Fragment>
        {weeklyData ?
            <Chart
            width={'100%'}
            loader = {loaderElement}
            chartType="ColumnChart"
            data={weeklyData}
            options={{
            title: 'Weeks by Block Type',
            chartArea: { width: '50%' },
            isStacked: true,
            
            hAxis: {
                title: 'Δ Weeks',
                minValue: 0,
            },
            vAxis: {
                title: '# Blocks',
            },
            series: {
                0:{color: roundsColor},
                1:{color: bookedColor},
                2:{color: openColor},
            }
            }}
            // For tests
            rootProps={{ 'data-testid': '3' }}
            />
            :loaderElement
            
        }
    </React.Fragment>
)
}